<div>
  <div class="container">
    <div>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
